import React, { FC } from "react";
import GenericInformationStep from "../../Wizard/GenericInformationStep/GenericInformationStep";

const ProfileSetupDoneStep: FC = () => {
   return <GenericInformationStep />;
};

export default ProfileSetupDoneStep;
